<div class="greyboxPayment">
    <!-- <div class="conclass-new">
        <div class="row justify-center">
            <p class="payTXT">
                Your payment has been successful
            </p>
        </div>
        <div class="row transactionDetails">
            <div>First Name:&nbsp;{{firstName}}</div>
        </div>
        <div class="row transactionDetails">
            <div>Last Name:&nbsp;{{lastName}}</div>
        </div>
        <div class="row transactionDetails">
            <div>Transaction ID:&nbsp;{{transactionId}}</div>
        </div>
        <div class="row transactionDetails">
            <div>Amount:&nbsp;${{amount}}</div>
        </div>
        <div class="row justify-center pt-4">
            <button class="backBtn">Back</button>
            <button class="gohomeBTN"><a href="https://www.travelance.ca/" class="gohome">Go to Home</a></button>
        </div>
    </div> -->
    <div class="row">
        <div>
            
            <button class="backBtn ml-3" routerLink="/dashboard/sales-home"><img class="cp" src="./assets/images/backarrow.png"> Return Home</button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
            <img class="mb-3" src="./assets/images/successtikMark.png">
            <div class="mb-3">
                <label class="fs-20 bold">PURCHASE CONFIRMED.</label>
            </div>
            <div class="mb-3">
                <label class="fs-18 regular">The policy number is {{policyNumber}}</label>
            </div>
            <div class="">
                <label class="fs-18 regular">The confirmation of coverage has been sent to:</label>
            </div>
            <div class="mb-2">
                <label class="fs-18 bold">{{purchaserEmail}}</label>
            </div>
            <div class="mb-3">
                <!-- <button type="button" class="regular gohomeBTN" (click)="printPopup=!printPopup">Email More</button>             -->
                <button type="button" class="regular gohomeBTN" (click)="printPopup=!printPopup">Email to Other Recipients</button>            
            </div>
            <div class="mb-3">
                <button type="button" class="fs-16 regular cardBoxBlueBorder" (click)="getPolicyDocs()">Download Policy Package<img class="floatRight h22" src="./assets/images/downloadIcon.svg"></button>            
            </div>
            <!-- <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                    <div class="cardBoxBlueBorder mr-1">
                        <div class="row cp" (click)="onPolicyCoc()">
                            <div class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 text-left">
                                <label class="fs-18 regular mb-0">Download/review</label><br>
                                <label class="fs-14 regular mb-0">copy of your <span class="bold">policy confirmation (COC).</span></label>
                            </div>
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right">
                                <img src="./assets/images/blueDownloadFileIcon.png">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div class="cardBoxRedBorder ml-1">
                        <div class="row cp" (click)="onSelectedBoxFile()">
                            <div class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 text-left">
                                <label class="fs-18 regular mb-0">Download/review</label><br>
                                <label class="fs-14 regular mb-0">Detailed copy of the <span class="bold">policy wording.</span></label>
                            </div>
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right">
                                <img src="./assets/images/redDownloadFileIcon.png"> 
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
    <!-- <div class="row"> -->
        <!-- <div class=""> -->
            <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"> -->
        <!-- <label class="regular fs-16 mb-0 footertext">If you require assistance, please contact your Broker or <a href="https://www.travelance.ca/contact-us/" target="_blank">Travelance</a>.</label><br> -->
        <!-- <label class="regular fs-14">Link “Travelance” to Travelance Contact page <a href="https://www.travelance.ca/contact-us/" target="_blank">https://www.travelance.ca/contact-us/</a></label> -->
            <!-- </div> -->
        <!-- </div> -->
    <!-- </div> -->
</div>
<div id="printPopup" class="modal" [style.display]="printPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header text-center">
            
            <h6 class="close text-right" (click)="clear();printPopup=!printPopup">&times;</h6>
            <div class="fs-16 bold">Email</div>
            <!-- <div class="clear10"></div>
            <div class="fs-16 link regular cp" (click)="printPopup=!printPopup"></div> -->
        </div>
        <div class="modal-body">
            <label class="fs-16 text46 regular">Share with</label><br>
            <div>
                <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com" [(ngModel)]="email1" (input)="onRemoveEmailError();emailCheck()">
                <p class="regular redstar" *ngIf="emailErrorFlag">Email is required</p>
                <p class="fs-14 regular redstar" *ngIf="emailNotValid">Email is not valid.</p>
            </div>
            <div class="clear20"></div>
            <div>
                <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com" [(ngModel)]="email2" (input)="emailCheck1()">
                <!-- <p class="regular redstar" *ngIf="emailErrorFlag">Email is required</p> -->
                <p class="fs-14 regular redstar" *ngIf="emailNotValid1">Email is not valid.</p>
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-14 bold okbtngreen" (click)="onSendEmail()">Send</button>
            </div>
        </div>
    </div>
    <!-- <div class="clear10"></div>
    <div class="modal-content">
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                    <label class="fs-16 text46 bold">View / Print</label><br>
                    <label class="fs-16 text46 regular">Confirmation of coverage</label>
                </div>
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                    <button type="submit" class="printbtn bold">Print</button>
                </div>
            </div>
        </div>
    </div> -->
  </div>
  <div id="viewPolicyDetails" class="modal" [style.display]="viewPolicyDetailsPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">Policy Wording</span>
            <h6 class="close text-right" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="clear50"></div>
            <div class="clear10"></div>
                <div class="row">
                    <div class="col-xl-12 text-right downloadbtn">
                    <div  class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <!-- <iframe class="iframe" src="https://travelance.box.com/v/isp-policy-eng" title="Policy Wording">
                </iframe> -->
                <iframe [src]='UrlBoxPolicy | sanitizePipe' height="550px" width="100%" title="Policy Wording"></iframe>
        </div>
    </div>
</div>